import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { AccentButtonMediumOpenSans } from '../../../../../styledComponents/styles/Buttons.styled';
import StyledIcon from '../../../../../styledComponents/styles/Icon.styled';
import ScreenReaderHeadingComponent from '../../../../travelerProfile/components/heading/ScreenReaderHeadingComponent';



const ConfirmContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 21px;
`;

const ValueContainer = styled.div`
  flex: 1;
  margin-left: 50px;
  text-align: initial;
`;

const LabelItem = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: 400;
`;

const ValueItem = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 18px;
  margin-top: 13px;
  padding-left: 30px;
  overflow-wrap: anywhere;
`;

const Header = styled.span`
  color: #0B3544;
  font-size: 28px;
  font-weight: 600;
  line-height: 74px;
`;

const Instructions = styled.div`
  color: #373737;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  
  span {
    font-weight: 600;
  }
`;

const SubmitContainer = styled.div`
  flex: 1;
  margin-top: 34px;
  text-align: center;
`;

const Error = styled.div`
  color: ${({ theme }) => theme.defaults.error.fontColor};
  display: inline-block;
  font-family: ${({ theme }) => theme.defaults.error.fontFamilyOpenSans};
  font-size: ${({ theme }) => theme.defaults.error.fontSize};
  font-weight: ${({ theme }) => theme.defaults.error.fontWeight};
  padding-top: 3px;
  vertical-align: middle;
  
  svg {
    justify-content: center;
    margin-right: 5px;

    vertical-align: middle;
    display: inline-block;
  }
  
  span {
    vertical-align: middle;
    display: inline-block;
  }
`;

// Step 4.
export default function ConfirmStep(props) {
  let { getValues, isValid, nextStep } = props;
  const [email, setEmail] = useState('');
  const [orgName, setOrgName] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const createUserAccountResponse = useSelector(state => state.authentication.createUserAccount);

  useEffect(() => {
    setEmail(getValues('email'));
    setOrgName(getValues('organizationName'));
  }, [props]);

  useEffect(() => {
    if (!isValid || (createUserAccountResponse && !createUserAccountResponse.loading && createUserAccountResponse.error)) {
      setErrorMsg('Error creating account. Try again.');
    }

    if (
      isValid &&
      createUserAccountResponse &&
      !createUserAccountResponse.loading &&
      !createUserAccountResponse.error &&
      createUserAccountResponse.data &&
      createUserAccountResponse.data.is_success
    ) {
      nextStep(5);
    }
  }, [createUserAccountResponse]);

  return (
    <>
      <ScreenReaderHeadingComponent text={"Confirm & Create"} />
      <Header>Confirm & Create</Header>
      <Instructions>Confirm account details & create your account</Instructions>
      <ConfirmContainer>
        <ValueContainer>
          <LabelItem>Email</LabelItem>
          <ValueItem>{email}</ValueItem>
        </ValueContainer>
        <ValueContainer>
          <LabelItem>Organization</LabelItem>
          <ValueItem>{orgName}</ValueItem>
        </ValueContainer>
      </ConfirmContainer>
      <SubmitContainer>
        <AccentButtonMediumOpenSans
          aria-label="Create Account"
          form="createAccount"
          type={'submit'}
        >
          Create Account
        </AccentButtonMediumOpenSans>
        {errorMsg && errorMsg.length > 0 && (
          <Error>
            <StyledIcon type={'Warning'} size={'16px'} />
            <span>{errorMsg}</span>
          </Error>
        )}
      </SubmitContainer>
    </>
  );
}